import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { ReactNode } from 'react';

interface Props {
    children?: ReactNode;
}

function Badge({ children }:Props) {
    return (
        <Wrapper aria-label='badge' >
            <BadgeText color={colors.gray6}
                fontWeight='bold' >
                {children}
            </BadgeText>
        </Wrapper>
    );
}

const Wrapper = styled.div`
    padding: 2px 4px;
    border-radius: 4px;
    background-color: var(--color-gray2);
    overflow: hidden;
`;

const BadgeText = styled(Text)`
    font-size: 10px !important;
    line-height: 14px;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;;
`;

export default Badge;
